 

<div class="rk-ui-notification err" *ngIf="erroralert" style="z-index: 10000;">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert" style="z-index: 10000;">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="row mt-4 right-section ppt-section">
  <div class="col-md-12">
    <button type="button" *ngIf="project_id" class="btn btn-pink pull-right" data-toggle="modal" data-target="#pptModal">
      UPLOAD PPT FILE
    </button>
  </div>
 <!--  <div class="col-md-12 mt-5 text-center p-5" style="background-color: #fff;" *ngIf="pptFileList && pptFileList.length == 0">
    <img src="../../../assets/img/nothing.png" class="img-fluid">
  </div> -->
  <div class="col-md-12 mt-5">
    <div class="row">
      <!-- Card -->
      <div class="col-md-4 mt-4" *ngFor="let obj of view_all; let i = index;">
        <div class="card sadowcard">
          <!-- Card image -->
          <div class="view overlay">
            <img *ngIf="i==2" src="./assets/img/MTO.png" class="card-img-top img-fluid" alt="Card image cap" style="max-height: 165px;" />
            <img *ngIf="i==1" src="./assets/img/FH.png" class="card-img-top img-fluid" alt="Card image cap" style="max-height: 165px;" />
            <img *ngIf="i==0" src="./assets/img/Delta.png" class="card-img-top img-fluid" alt="Card image cap" style="max-height: 165px;" />
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!-- Card content -->
          <div class="card-body">
            <!-- Title -->
            <p class="mb-0 mt-2" style="font-size:13px;">
              <span>File Name:</span><span style="color: #7E7E7E;">{{obj.sample_ppt_name}}</span>
            </p>
            <hr>
            <a class="btn btn-pink btn-chng pull-right" href="{{obj.sample_ppt_file}}" download target="_blank">
             Download
            </a>
          </div>
        </div>
      </div>
      <!-- Card -->
      <!-- default ppt card end -->
      <div class="col-md-4 mt-4" *ngFor="let obj of pptFileList">
        <div class="card card-chng">
          <i class="fa fa-trash trash-card" (click) = "deleteObject(obj.id)" *ngIf="role =='community_manager' && obj.shared_with_customer != true" ></i>
          <!-- <i class="fa fa-share-alt trash-card" (click) = "confirmAndShare(obj.id)" *ngIf="role =='designer' && obj.shared_with_customer != true " ></i> -->
        	<img onerror="this.src='./assets/img/no_image.svg';" class="card-img-top img-fluid" src="{{obj.upload}}" alt="Card image cap" style="max-height: 165px;" />

          <!-- <img class="card-img-top img-fluid" src="{{obj.ppt_file}}" alt="Card image cap" style="max-height: 165px;"> -->
          <div class="card-block" style="padding: 1rem;">
            <p class="card-text" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;border-bottom: 1px solid #e0e0e0;padding-bottom: 10px;">{{obj.name}}</p>
            <div class="row">
              <div class="col-md-12">
                <p class="mb-0" style="font-size:13px;">
                  <span>{{obj.type}} </span>
                </p>
                <p class="mb-0 mt-2" style="font-size:13px;">
                  <span>File Name: </span>
                  <span style="color: #7E7E7E;">{{obj.upload_file_name}}</span>
                </p>
                <!-- <p class="mb-0 mt-2" style="font-size:13px;">
                  <span>Customer Status: </span>
                  <span style="color: #1eb531;" *ngIf="obj.shared_with_customer == true">Shared</span>
                  <span style="color: #de3c22;" *ngIf="!obj.shared_with_customer">Pending</span>
                </p> -->
              </div>
              <div class="col-md-12 divbutton mt-2">
                <a class="btn btn-pink btn-chng pull-right" href="{{obj.upload}}" download target="_blank">
                  Download
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Start ppt modal -->
<div class="modal fade" id="pptModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
        <h6 class="modal-title" id="exampleModalLabel">Upload a PPT file : </h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <form (ngSubmit)="onSubmit(createPptForm.value); createPptForm.reset()" #createPptForm="ngForm" class="form-horizontal" enctype="multipart/form-data">
              <div class="form-group">
                <label for="name" class="ss-form-label">PPT Name</label>
                <input type="text" class="form-control ss-form-control" id="name" placeholder="A proper name for ppt file" required name="name" #name="ngModel" ngModel>

                <label for="ppt_file" class="ss-form-label mt-4">PPt File</label>
                <input type="file" class="form-control ss-form-control" (change)="onChange($event)" name="ppt_file" ngModel #ppt_file="ngModel" id="ppt_file"accept="application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation">

                <button type="submit" class="btn btn-pink button_emi pull-right mt-4" [disabled]="!createPptForm.valid || basefile == undefined"> Submit </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/lead/file-ppt/file-ppt.component.html